function isiOS() {
  return (
    // any apple-based device
    // iPad on iOS 13 detection
    typeof navigator !== "undefined" && (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}
export {
  isiOS
};
//# sourceMappingURL=is-ios.js.map
